import React from 'react';

const OrderButton = props => {
    if (!props) return null;

    const {
        textsMapping,
        isLoading,
        onOrderClick
    } = props;

    return (
        <button
            className={`order-button button ${isLoading ? 'button__loader' : ''}`}
            onClick={onOrderClick}
        >
            {textsMapping.orderButtonText}
        </button>
    )
}

export default OrderButton;